import axiosInstance from "./authentication/axiosInstance";

export const leaveBalanceServices = {

  getBalanceByUserId: async (userId) => {
    const response = await axiosInstance.get(`/leave-balance/user/${userId}`);
    return response.data;
  },

  getAllBalances: async (search = '', page = 0, size = 10, sortField = 'id', sortDir = 'desc') => {
    const params = new URLSearchParams({
      pageNo: page,
      size,
      sortField,
      sortDir,
    });
    if (search) params.set('search', search);
    const response = await axiosInstance.get(`/leave-balance/all?${params.toString()}`);
    return response.data;
  },

  adjustBalance: async (payload) => {
    const response = await axiosInstance.post('/leave-balance/adjust', payload);
    return response.data;
  },

  getConfig: async () => {
    const response = await axiosInstance.get('/leave-balance/config');
    return response.data;
  },

  updateConfig: async (payload) => {
    const response = await axiosInstance.put('/leave-balance/config', payload);
    return response.data;
  },

  getAuditLog: async (userId, page = 0, size = 10, sortField = 'createdAt', sortDir = 'desc') => {
    const params = new URLSearchParams({
      pageNo: page,
      size,
      sortField,
      sortDir,
    });
    const response = await axiosInstance.get(`/leave-balance/audit/${userId}?${params.toString()}`);
    return response.data;
  },

  triggerMonthlyCredit: async () => {
    const response = await axiosInstance.post('/leave-balance/trigger-monthly-credit');
    return response.data;
  },

};
